module.exports = __webpack_public_path__ + "static/media/squared-plus.cb35a716.svg";